
import React, {Component} from 'react';
import {Modal,FormControl,Button,ButtonToolbar} from 'react-bootstrap'
// import Select from 'react-select'
import HrStore from '../../stores/HrStore'
class ContractorEditModal extends Component {

  constructor(...args){
    super(...args)
    this.state = this.initItem()
  }

  initItem(){
    return {contractor_id:'',first_name:'',last_name:'',nick_name:'',position:''}
  }

  loadItemcode(item){
    console.log('loadItem',item)
    if(item!==null)
      this.setState(Object.assign(this.state,item,{catSelect:this.getSelectOption(item.customer_type)}))
    else
      this.setState(this.initItem());
  }

  getSelectOption(categoryId){
    let catSelect = null
    this.props.catOptions.forEach((item,index)=>{
      if(item.value===categoryId){
        catSelect = item
      }
    })

    return catSelect

  }

  onTextChange(field,e){
    let state = this.state
    state[field] = e.target.value
    this.setState(state)
  }

  onSelectChange(value){
    // let {catSelect} = this.state

    this.setState({catSelect:value})
  }

  onDelClick(){
    let that = this
    let {customer_id} = this.state
    
    //console.log('postData',postData)
    HrStore.delContractor(customer_id,function(){
      that.props.onAfterSubmit(customer_id);
      that.props.onHide()
    })
  }

  onSaveClick(){
    let that = this
    let {contractor_id,first_name,last_name,nick_name,position} = this.state
    let postData = {customer_id:contractor_id,first_name:first_name,last_name:last_name,nick_name:nick_name,position:position}
    
    //console.log('postData',postData)
    HrStore.saveContractor(postData,function(){
      that.props.onAfterSubmit(postData);
      that.props.onHide()
    })
  }

  renderHeader(){
    return (
      <div className='row form-group'>
        <div className='col-md-3'>
          ชื่อ
        </div>
        <div className='col-md-3'>
          นามสกุล
        </div>
        <div className='col-md-3'>
          ชื่อเล่น
        </div>
        <div className='col-md-3'>
          ตำแหน่ง
        </div>
        
      </div>        
    )
  }

  renderForm(){
    let {first_name,last_name,nick_name,position} = this.state
    
    return (
      <div className='row form-group'>
        
        <div className='col-md-3' style={{display:'inline-flex'}}>
          <FormControl value={first_name} onChange={this.onTextChange.bind(this,'first_name')}/>          
        </div> 
        <div className='col-md-3' style={{display:'inline-flex'}}>
          <FormControl value={last_name} onChange={this.onTextChange.bind(this,'last_name')}/>          
        </div> 
        <div className='col-md-3' style={{display:'inline-flex'}}>
          <FormControl value={nick_name} onChange={this.onTextChange.bind(this,'nick_name')}/>          
        </div> 
        <div className='col-md-3' style={{display:'inline-flex'}}>
          <FormControl value={position} onChange={this.onTextChange.bind(this,'position')}/>          
        </div> 
        
      </div>
    )
  }

  render(){
    let {show} = this.props
    let {contractor_id} = this.state

    let title = ''
    if(contractor_id===''){
      title = 'เพิ่มช่างเหมาในระบบ'
    }else{
      title = 'แก้ไขรายละเอียดช่างเหมา'
    }
    return (
      <Modal show={show} enforceFocus={false} onHide={this.props.onHide} dialogClassName="midwidth-dialog">
        <Modal.Header closeButton>
          <Modal.Title>{title}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {this.renderHeader()}
          {this.renderForm()}
        </Modal.Body>
        <Modal.Footer>
          <ButtonToolbar className='pull-right'>
          <Button style={{display:'none'}} bsStyle={'danger'}  onClick={this.onDelClick.bind(this)}>ลบข้อมูล</Button>
          <Button bsStyle={'primary'}  onClick={this.onSaveClick.bind(this)}>บันทึกข้อมูล</Button>
          <Button onClick={this.props.onHide}>ยกเลิก</Button>
          </ButtonToolbar>
        </Modal.Footer>
      </Modal>
    )
  }
}


export default ContractorEditModal;





// WEBPACK FOOTER //
// ./src/view/hr/ContractorEditModal.js